module.exports = __webpack_public_path__ + "img/sztd5.0c86eefd.png";